import React, { useState } from 'react';
import api from '../api';

export default function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setError('');
    setBusy(true);
    try {
      const { data } = await api.post('/login', { username, password });
      onLogin(data.token);
    } catch {
      setError('Invalid username or password');
    } finally {
      setBusy(false);
    }
  };

  const onKey = (e) => e.key === 'Enter' && submit();

  return (
    <div style={s.wrap}>
      <div style={s.card}>
        <div style={s.brand}>
          Med<span style={{ color: 'var(--teal)' }}>Copy</span>USA
        </div>
        <div style={s.sub}>Outreach Dashboard</div>

        <input
          style={s.input}
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          onKeyDown={onKey}
        />
        <input
          style={s.input}
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={onKey}
        />

        {error && <div style={s.error}>{error}</div>}

        <button style={s.btn} onClick={submit} disabled={busy}>
          {busy ? 'Signing in…' : 'Sign in'}
        </button>
      </div>
    </div>
  );
}

const s = {
  wrap: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #2d3748 0%, #1f2733 100%)',
  },
  card: {
    width: 340,
    background: '#fff',
    borderRadius: 14,
    padding: '36px 32px',
    boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
  },
  brand: { fontSize: 26, fontWeight: 800, color: 'var(--navy)', textAlign: 'center' },
  sub: {
    fontSize: 13,
    color: 'var(--muted)',
    textAlign: 'center',
    marginTop: 4,
    marginBottom: 26,
  },
  input: {
    width: '100%',
    padding: '12px 14px',
    marginBottom: 12,
    border: '1px solid var(--border)',
    borderRadius: 8,
    fontSize: 14,
    outline: 'none',
  },
  btn: {
    width: '100%',
    padding: '12px',
    marginTop: 6,
    background: 'var(--teal)',
    color: '#fff',
    border: 'none',
    borderRadius: 8,
    fontSize: 15,
    fontWeight: 600,
  },
  error: {
    background: '#fff5f5',
    color: '#c53030',
    fontSize: 13,
    padding: '8px 12px',
    borderRadius: 6,
    marginBottom: 12,
  },
};
